import React, { useState } from "react";
import { IoClose } from "react-icons/io5";
import { FaSave } from "react-icons/fa";
import { MdDataSaverOff } from "react-icons/md";
import { Input, DatePickerComp, Select, Textarea } from "../Form";
import ReactDatePicker from "react-datepicker";
import { BiChevronDown, BiTrash } from 'react-icons/bi';
import "react-datepicker/dist/react-datepicker.css";

const sendToData = [
  {
    id: 1,
    name: 'All Patients',
    value: 'all',
  },
  {
    id: 2,
    name: 'NHCF Patients',
    value: 'nhcf',
  },
  {
    id: 3,
    name: 'Britam Patients',
    value: 'britam',
  },
];

const AddMaterial = ({ isOpen, onClose }) => {
  const [selectedOption, setSelectedOption] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [sendTo, setSendTo] = useState(sendToData[0].name);
  
  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50 overflow-y-scroll">
      <div className="bg-white md:p-5 p-4 rounded shadow-md md:w-[80%] w-full md:m-0 m-3 h-100 overflow-y-scroll">
        <div className="flex gap-5 justify-between">
          <button
            className=" uppercase text-red-500 flex items-center md:gap-2 gap-1"
            onClick={onClose}
          >
            <IoClose className="font-semibold uppercase" />
            cancel
          </button>
          <h1 className="uppercase text-[#66b5a3] font-semibold">Materials</h1>
          <button
            className=" uppercase hover:text-[#539e93] text-[#66b5a3] flex items-center md:gap-2 gap-1"
            onClick={onClose}
          >
            <FaSave className=" font-semibold uppercase" />
            save
          </button>
        </div>

        <div className="pt-5">
          
          <div className="flex justify-between items-center">
          <Input
            type="text"
            label="Name:"
            color={true}
            placeholder={"Enter Number"}
          />
          </div>

          <div className="flex justify-between items-center">
          <Input
            type="number:"
            label="Code:"
            color={true}
            placeholder={"Enter Number"}
            />
          </div>
          
          <div className="my-3">
          <Select
            label="Unit:"
            color={true}
            selectedPerson={sendTo}
            setSelectedPerson={setSendTo}
            datas={sendToData}
          >
            <div className="h-14 w-full text-xs text-main rounded-md bg-white border border-border px-4 flex items-center justify-between">
              <p>{sendTo}</p>
              <BiChevronDown className="text-xl" />
            </div>
          </Select>
          </div>

          <div className="flex justify-between items-center">
          <Textarea
            type="text"
            label="Description:"
            rows={2}
            color={true}
            placeholder={"Description"}
            />
          </div>

          <button
            className=" uppercase flex items-center gap-2 md:mt-8 mt-4 bg-[#66b5a3] hover:bg-[#539e93] text-white justify-center w-full rounded-md p-3"
            onClick={onClose}
          >
            <FaSave className="text-white font-semibold uppercase" />
            save
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddMaterial;
